import { render, staticRenderFns } from "./overdue-bills.vue?vue&type=template&id=2aaae8f8&"
import script from "./overdue-bills.vue?vue&type=script&lang=js&"
export * from "./overdue-bills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports